export default __webpack_public_path__ + "static/media/byoc-step3.28f3f697.svg";